module.exports = __webpack_public_path__ + "72ff81d043a259a1d8f54e5c7b3009e4.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/Goldencity-voll.jpg
// module id = 790
// module chunks = 0